import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FavoriteService {
  constructor(private http: HttpClient) {}

  public addFavorite(parentId: string): Observable<object> {
    return this.http.post(`${environment.apiUrl}/favorites?parentId=${parentId}`, null);
  }

  public deleteFavorite(parentId: string): Observable<object> {
    return this.http.delete(`${environment.apiUrl}/favorites?parentId=${parentId}`);
  }
}
